import type { UpdateSettingsInput, UserSettingsDTO } from '@clanfire/shared';
import { errorMessage } from '@/api/client';
import { userApi } from '@/api/endpoints';
import { useAuth } from '@/stores/auth';
import { toast } from '@/stores/ui';

/** Shows a settings change right away, without saving it (e.g. while dragging a colour picker). */
export function previewSettings(patch: UpdateSettingsInput) {
  const current = useAuth.getState().settings;
  if (current) useAuth.getState().setSettings({ ...current, ...patch } as UserSettingsDTO);
}

/**
 * Applies a settings change right away and saves it to your account (so your
 * other devices get it too), undoing it if the save fails. `before` is what to
 * go back to, when the change was already being previewed.
 */
export async function saveSettings(patch: UpdateSettingsInput, before?: UserSettingsDTO): Promise<boolean> {
  const previous = before ?? useAuth.getState().settings;
  if (!previous) return false;
  previewSettings(patch);
  try {
    useAuth.getState().setSettings(await userApi.updateSettings(patch));
    return true;
  } catch (err) {
    useAuth.getState().setSettings(previous);
    toast.error(errorMessage(err, 'Could not save your settings.'));
    return false;
  }
}
